export default __webpack_public_path__ + "static/media/dart.8b2ac340.svg";